var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header',{attrs:{"title":"Embajada de la República Bolivariana de Venezuela en Australia"}}),(_vm.$store.state.session)?_c('b-container',{attrs:{"fluid":""}},[_c('b-col',[_c('Menu')],1),_c('b-col',[_c('router-view')],1)],1):_c('b-container',{attrs:{"fluid":""}},[_c('login')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }